// Helpers
import {
    ALPHABET_TEST,
    WRITING_TRAININGWORDS_TEST,
    READING_TRAININGWORDS_TEST,
    TRAINING_SENTENCES_TEST,
    READING_ALOUD_TEST,
    SYLLABLE_TEST
} from "../helpers/constants";
// Theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

// Chart Colors
export const colorMap = {
    [ALPHABET_TEST]: ["#314F6F", "#558E86"],
    [READING_TRAININGWORDS_TEST]: ["#558E86", "#cad8e7", "#314F6F"],
    [WRITING_TRAININGWORDS_TEST]: ["#cde1e0", "#A8CAC9", "#558E86", "#cad8e7", "#314F6F"],
    [TRAINING_SENTENCES_TEST]: ["#314F6F", "#558E86"],
    [READING_ALOUD_TEST]: ["#558E86", "#cad8e7", "#C51D34", "#1D1E33"],
    [SYLLABLE_TEST]: ["#558E86", "#314F6F"]
};
// Chart Strokes
export const strokeWidth = {
    [READING_TRAININGWORDS_TEST]: [1, 1, 4],
    [WRITING_TRAININGWORDS_TEST]: [1, 1, 1, 1, 4],
    [READING_ALOUD_TEST]: [1, 1, 4, 4],
    [SYLLABLE_TEST]: [4, 1]
};

export const iframeStyle = {
    border: 0,
    boxShadow: "none",
    width: "100%",
    height: "100%"
};
